<!--提问-->
<template>
  <div class="el-OnlineLearning">
    <el-row class="page_content">
      <h1 class="head_title" style="margin-bottom:0;">
        {{courseName}} 提问
        <el-button style="float: right;margin-top: -7px;" @click="closePage">关 闭</el-button>
      </h1>
      <div class="bg_"></div>
      <el-row>
        <el-col :span="8" style="margin-left:20px;width:300px;">
          <el-input placeholder="请输入内容" v-model="input1" class="input-with-select">

          </el-input>
        </el-col>
        <el-col :span="8">
          <el-button type="warning" icon="el-icon-search" @click="searchInfo" style="margin-left:15px;">查询</el-button>
          <el-button type="success" @click="addQuestions">提问</el-button>
        </el-col>
      </el-row>
      <el-tabs v-model="isHot" @tab-click="handleClick" style="padding: 20px 20px 0;">
        <el-tab-pane label="热门" name="1">
          <div style="width: calc(100% - 350px);">
            <el-row v-for='(item,index) in tableData' :key="index" style="border-bottom: 1px solid #a3a6ac;padding: 0 20px;">
              <h1 style="color:#67C23A;font-size:20px;">
                {{item.messageConcat}}
              </h1>
              <el-row style="margin-bottom: 15px;">
                <span class="icon_ iconfont">&#xe603;</span>
                <span class="icon_">{{item.messageChildrenList != null?item.messageChildrenList.length:0}}</span>
                <span class="icon_ iconfont" @click="editLike(item,index)" v-if="item.isLike != 1">&#xec7f;</span>
                <span class="icon_ iconfont onIcon" @click="editLike(item,index)" v-if="item.isLike == 1">&#xe668;</span>
                <span class="icon_">{{item.likesNum || 0}}</span>
                <span class="icon_ iconfont" @click="collection(item,index)" v-if="item.isCollection != 1">&#xe8b9;</span>
                <span class="icon_ iconfont onIcon" @click="collection(item,index)" v-if="item.isCollection == 1">&#xe8c6;</span>
                <span class="icon_">{{item.messageCollectionNum || 0}}</span>
                <span style="float: right;margin-top:10px;color:#6d757a;">{{$timeFormat(item.messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
              </el-row>
              <template v-if="item.messageChildrenList != null && item.messageChildrenList.length > 0 ">
                <el-row style="max-height: 500px;overflow-y: auto;">
                  <el-row v-for='(it,ind) in (item.messageChildrenList.length >=2?2:item.messageChildrenList.length)' :key="index+'_mase'"   style="border-top: 1px solid rgb(243, 243, 243); padding: 0px 30px 10px;">
                    <img :src="rzImg" class="rzImg" />
                    <p style="line-height:25px;">
                      <span style="color:#6d757a;">{{item.messageChildrenList[ind].sendName}} ：</span>
                      {{item.messageChildrenList[ind].messageConcat}}
                    </p>
                    <span style="color: rgb(153, 162, 170);margin-left: 42px;font-size: 14px;">{{$timeFormat(item.messageChildrenList[ind].messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
                  </el-row>
                  <el-row v-for='(it,ind) in (map["1id"+index] == item.messageId?item.messageChildrenList.length - 2:0)' :key="index+'_rz'" style="border-top: 1px solid rgb(243, 243, 243); padding: 0px 30px 10px;">
                    <img :src="rzImg" class="rzImg" />
                    <p style="line-height:25px;">
                      <span style="color:#6d757a;">{{item.messageChildrenList[ind+2].sendName}} ：</span>
                      {{item.messageChildrenList[ind+2].messageConcat}}
                    </p>
                    <span style="color: rgb(153, 162, 170);margin-left: 42px;font-size: 14px;">{{$timeFormat(item.messageChildrenList[ind+2].messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
                  </el-row>
                  <el-row v-if="map['1id'+index] != item.messageId && item.messageChildrenList.length > 2" :key="index+'_rzc'"  style="text-align: center;margin-bottom: 10px;">
                    <el-button @click="loadMore(item,index)" >更多 >></el-button>
                  </el-row>
                </el-row>
              </template>
            </el-row>

            <div class="block">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="currentPage1" :page-size="limit" :hide-on-single-page="true"
                layout="total, prev, pager, next" :total="total">
              </el-pagination>
            </div>
            <el-empty v-if="tableData.length <= 0" description="暂无数据"></el-empty>
          </div>
        </el-tab-pane>
        <el-tab-pane label="所有" name="2">
          <div style="width: calc(100% - 350px);">
            <el-row v-for='(item,index) in allTableData' :key="index+'_all'" style="border-bottom: 1px solid #a3a6ac;padding: 0 20px;">
              <h1 style="color:#67C23A;font-size:20px;">
                {{item.messageConcat}}
              </h1>
              <el-row style="margin-bottom: 15px;">
                <span class="icon_ iconfont">&#xe603;</span>
                <span class="icon_">{{item.messageChildrenList != null?item.messageChildrenList.length:0}}</span>
                <span class="icon_ iconfont" @click="editLike(item,index)" v-if="item.isLike != 1">&#xec7f;</span>
                <span class="icon_ iconfont onIcon" @click="editLike(item,index)" v-if="item.isLike == 1">&#xe668;</span>
                <span class="icon_">{{item.likesNum || 0}}</span>
                <span class="icon_ iconfont" @click="collection(item,index)" v-if="item.isCollection != 1">&#xe8b9;</span>
                <span class="icon_ iconfont onIcon" @click="collection(item,index)" v-if="item.isCollection == 1">&#xe8c6;</span>
                <span class="icon_">{{item.messageCollectionNum || 0}}</span>
                <span style="float: right;margin-top:10px;color:#6d757a;">{{$timeFormat(item.messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
              </el-row>
              <template v-if="item.messageChildrenList != null && item.messageChildrenList.length > 0 ">
                <el-row style="max-height: 500px;overflow-y: auto;">
                  <el-row v-for='(it,ind) in (item.messageChildrenList.length >=2?2:item.messageChildrenList.length)' :key="index+'_msg'" style="border-top: 1px solid rgb(243, 243, 243); padding: 0px 30px 10px;">
                    <img :src="rzImg" class="rzImg" />
                    <p style="line-height:25px;">
                      <span style="color:#6d757a;">{{item.messageChildrenList[ind].sendName}} ：</span>
                      {{item.messageChildrenList[ind].messageConcat}}
                    </p>
                    <span style="color: rgb(153, 162, 170);margin-left: 42px;font-size: 14px;">{{$timeFormat(item.messageChildrenList[ind].messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
                  </el-row>
                  <el-row v-for='(it,ind) in (map["2id"+index] == item.messageId?item.messageChildrenList.length - 2:0)' :key="index+'_map'" style="border-top: 1px solid rgb(243, 243, 243); padding: 0px 30px 10px;">
                    <img :src="rzImg" class="rzImg" />
                    <p style="line-height:25px;">
                      <span style="color:#6d757a;">{{item.messageChildrenList[ind+2].sendName}} ：</span>
                      {{item.messageChildrenList[ind+2].messageConcat}}
                    </p>
                    <span style="color: rgb(153, 162, 170);margin-left: 42px;font-size: 14px;">{{$timeFormat(item.messageChildrenList[ind+2].messageAddTime, 'yyyy-MM-dd HH:mm')}}</span>
                  </el-row>
                  <el-row v-if="map['2id'+index] != item.messageId && item.messageChildrenList.length > 2" style="text-align: center;margin-bottom: 10px;">
                    <el-button @click="loadMore(item,index)" >更多 >></el-button>
                  </el-row>
                </el-row>
              </template>
            </el-row>
            <div class="block">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="allCurrentPage1" :page-size="limit" :hide-on-single-page="true"
                layout="total, prev, pager, next" :total="allTotal">
              </el-pagination>
            </div>
            <el-empty v-if="allTableData.length <= 0" description="暂无数据"></el-empty>
            </div>
        </el-tab-pane>
      </el-tabs>
      <div class="userPutQues">
        <ul>
          <li :class="leavingMessageType == 1?'onType':''" @click="leavingMessage(1)">全部问题</li>
          <li :class="leavingMessageType == 2?'onType':''" @click="leavingMessage(2)">未回答问题</li>
          <li :class="leavingMessageType == 3?'onType':''" @click="leavingMessage(3)">我收藏的问题</li>
          <li :class="leavingMessageType == 4?'onType':''" @click="leavingMessage(4)">我的问题</li>
        </ul>
      </div>

    </el-row>
    <el-dialog title="提交问题" :visible.sync="dialogFormVisible" width="600px">
      <el-input type="textarea" :rows="4" placeholder="请输入问题" v-model="messageConcat">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import rzImg from '@/images/user/rz.png';
  export default {
    name: "OnlineLearning",
    data() {
      return {
        courseName:this.$Base64.decode(this.$route.query.courseName), //课程名称
        map:{}, //存储判断点击查看更多评论按钮数据
        tePlanCourseId: this.$route.query.tePlanCourseId, //课程id
        rzImg: rzImg,
        input1: "",
        isHot: "1", //是否热门 1热门
        leavingMessageType: 1, //留言类型 1全部问题 2未回答问题 3我收藏的问题 4我的问题
        tableData: [], //当前学期List
        allTableData: [], //所有学期List
        dialogFormVisible: false,
        messageConcat: "",
        currentPage1: 1,
        allCurrentPage1: 1,
        total: 0,
        allTotal: 0,
        limit: 6,
        page: 1
      };
    },
    created() {
      this.getLeavingMessageQuery();
    },
    methods: {
      closePage() {
        window.location.href = "about:blank";
        window.close();
      },
      handleClick(tab, event) {
        this.currentPage1 = 1;
        this.getLeavingMessageQuery();
      },
      searchInfo(){ //搜索
        this.getLeavingMessageQuery();
      },
      addQuestions() { //添加问题
        this.dialogFormVisible = true;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getLeavingMessageQuery();
      },
      leavingMessage(v) {
        if (this.leavingMessageType == v) {
          return;
        }
        this.leavingMessageType = v;
        this.getLeavingMessageQuery();
      },
      getLeavingMessageQuery() {
        const param = {
          tePlanCourseId: this.tePlanCourseId,
          isHot: this.isHot,
          leavingMessageType: this.leavingMessageType,
          limit: this.limit,
          page: this.page,
          messageConcat:this.input1
        }
        this.$store.dispatch("user/getLeavingMessageQuery", param).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            // this.courseName = ret.courseName;
            if(this.isHot == "1"){
              this.tableData = ret.data;
              this.total = ret.count;
            }else{
              this.allTableData = ret.data;
              this.allTotal = ret.count;
            }
          }
        });
      },
      submitInfo() { //提交问题
        const param = {
          tePlanCourseId: this.tePlanCourseId,
          messageConcat: this.messageConcat
        }
        this.$store.dispatch("user/addLeavingMessage", param).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            this.$message({
              message: "提交成功！",
              type: 'success'
            });
            this.messageConcat = "";
            this.dialogFormVisible = false;
            this.getLeavingMessageQuery();
          }
        });
      },
      editLike(obj,index) { //点赞/取消点赞
        this.$store.dispatch("user/editLike", {messageId: obj.messageId}).then((ret) => {
          if (ret.code == 0) {
            this.$message({
              message: "操作成功！",
              type: 'success'
            });
            if(this.isHot == "1"){
              this.tableData[index].isLike = ret.isLike;
              let likesNum = this.tableData[index].likesNum;
              if(ret.isLike == 1){
                this.tableData[index].likesNum = likesNum + 1;
              }else{
                this.tableData[index].likesNum = likesNum - 1;
              }
            }else{
              this.allTableData[index].isLike = ret.isLike;
              let likesNum = this.allTableData[index].likesNum;
              if(ret.isLike == 1){
                this.allTableData[index].likesNum = likesNum + 1;
              }else{
                this.allTableData[index].likesNum = likesNum - 1;
              }
            }
          } else {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          }
        });
      },
      collection(obj,index) { //收藏/取消收藏
        this.$store.dispatch("user/collection", {messageId: obj.messageId}).then((ret) => {
          if (ret.code == 0) {
            this.$message({
              message: "操作成功！",
              type: 'success'
            });
            if(this.isHot == "1"){
              this.tableData[index].isCollection = ret.isCollectionNum;
              let messageCollectionNum = this.tableData[index].messageCollectionNum;
              if(ret.isCollectionNum == 1){
                this.tableData[index].messageCollectionNum = messageCollectionNum + 1;
              }else{
                this.tableData[index].messageCollectionNum = messageCollectionNum - 1;
              }
            }else{
              this.allTableData[index].isCollection = ret.isCollectionNum;
              let messageCollectionNum = this.allTableData[index].messageCollectionNum;
              if(ret.isCollectionNum == 1){
                this.allTableData[index].messageCollectionNum = messageCollectionNum + 1;
              }else{
                this.allTableData[index].messageCollectionNum = messageCollectionNum - 1;
              }
            }
          } else {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          }
        });
      },
      loadMore(item,index){ //加载更多回复
        this.map[this.isHot+"id"+index] = item.messageId;
        this.map = Object.assign({},this.map);
      }
    }
  };
</script>
<style lang="less">
  @import '../../styles/base.less';

  .el-OnlineLearning {
    .wd {
      color: @red;
    }
    .onIcon{
      color: #73a1f7;
    }
    .el-dialog__body {
      border-top: 1px solid #ebeef5;
    }

    .el-link.el-link--primary {
      padding: 0 20px;
    }

    .el-tabs__item {
      font-size: 20px;
    }

    .bg_ {
      height: 10px;
      background-color: #f3f3f3;
      margin: 0 -20px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 10px;
    }

    .el-select .el-input {
      width: 130px;
    }

    .userPutQues {
      width: 300px;
      border: 1px solid #e4e7ed;
      text-align: center;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: none;
      position: absolute;
      right: 47px;
      top: 220px;

      ul {
        margin: 0;
        padding: 0;
        color: #67C23A;
        font-size: 18px;
      }

      li {
        list-style: none;
        line-height: 50px;
        border-bottom: 1px solid #e4e7ed;
        cursor: pointer;
      }

      ul li:first-child {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .onType{
        background-color: #67C23A;
        color: white;
      }
    }

    .block {
      text-align: center;
      width: 96%;
      margin-bottom: 20px;
      margin-top: 20px;
    }

    .page_content::-webkit-scrollbar {
      display: none;
    }

    .iconfont {
      margin-left: 30px;
      font-size: 30px;
      padding: 0 !important;
    }

    .icon_ {
      float: left;
      line-height: 28px;
      padding: 0 5px;
      width: 30px;
      cursor: pointer;
    }

    .icon_:hover {
      color: #409EFF;
    }

    .rzImg {
      width: 30px;
      height: 30px;
      float: left;
      margin-right: 13px;
      margin-top: 13px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/PutQuestions.vue